import { render } from "./ListItem.vue?vue&type=template&id=b82b2298"
import script from "./ListItem.vue?vue&type=script&lang=js"
export * from "./ListItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/simon/Sites/vafabmiljo.se/wp-content/plugins/site-widgets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__